import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import './responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import './fonts/gothambold-webfont.woff';
import './fonts/gothambold-webfont.woff2';
import ScrollToTop from './v2/components/ScrollToTop';
import 'react-tooltip/dist/react-tooltip.css';
import useUserStore from './zustand/fcmToken';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { Provider } from 'react-redux';
import { store } from './redux/store';

const fcmStore = useUserStore.getState();

const firebaseConfig = {
  apiKey: "AIzaSyA5z8jiDCJvgaRbKx9v9PwSArl6jEj71EY",
  authDomain: "doctolinkapp-bbaa3.firebaseapp.com",
  projectId: "doctolinkapp-bbaa3",
  storageBucket: "doctolinkapp-bbaa3.appspot.com",
  messagingSenderId: "154700497240",
  appId: "1:154700497240:web:6801cce73305b996d4a52d",
  measurementId: "G-JL9E2YBB2W"
};


const firebaseApp = initializeApp(firebaseConfig);


isSupported().then((supported) => {
  if (supported) {
    const messaging = getMessaging(firebaseApp);

    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        getToken(messaging, {
          vapidKey: "BOVLoQUQPKM6RTQCJieCvmi-6rJGZaVBu4eIv91hEaYL5kHDG6s2E9IAiHjhwn7sbsk7bIxLL77kVgNuIBGqxhA"
        }).then((currentToken) => {
          if (currentToken) {
            fcmStore.setFcmToken(currentToken);
          } else {
            console.log("No registration token available.");
          }
        }).catch((err) => {
          console.log("Error retrieving token:", err);
        });
      } else if (permission === 'denied') {
        console.log("Notification permission was denied by the user.");
      } else {
        console.log("Notification permission not granted.");
      }
    });

    onMessage(messaging, (payload) => {
      // console.log("Message received in foreground: ", payload);
    });

    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log('Service Worker registered with scope:', registration.scope);
          })
          .catch((err) => {
            console.error('Service Worker registration failed:', err);
          });
      });
    }

  } else {
    console.log("Firebase messaging is not supported in this browser (e.g., Safari).");
  }
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

// ✅ Optional: Report performance
reportWebVitals();
